var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "container",
    class: _vm.client ? "container-client" : ""
  }, [_c("div", {
    staticClass: "moment-bg"
  }), _c("div", {
    staticClass: "gradient-bg"
  }), _c("section", {
    staticClass: "content-wrap"
  }, [_c("base-info", {
    attrs: {
      data: _vm.liveInfo,
      client: _vm.client
    }
  }), _c("section", {
    staticClass: "title"
  }, [_c("div", {
    staticClass: "title-animate"
  }, [_c("div", {
    class: [_vm.animate ? "marquee-content" : ""]
  }, [_c("span", [_vm._v(_vm._s(_vm.liveInfo.liveName))])])])]), _c("section", {
    staticClass: "video-wrap"
  }, [_c("div", {
    staticClass: "status"
  }, [_vm.liveInfo.status == 1 ? _c("img", {
    attrs: {
      src: require("@/assets/images/live/img_suspend@2x.png")
    }
  }) : _vm._e(), _vm.liveInfo.status == 2 ? _c("img", {
    attrs: {
      src: require("@/assets/images/live/img_direct@2x.png")
    }
  }) : _vm._e(), _vm.liveInfo.status == 3 ? _c("img", {
    attrs: {
      src: require("@/assets/images/live/img_finish@2x.png")
    }
  }) : _vm._e(), _vm.liveInfo.status == 4 ? _c("img", {
    attrs: {
      src: require("@/assets/images/live/img_back@2x.png")
    }
  }) : _vm._e()]), _vm.playerOptions.video.url != "" ? _c("d-player", {
    ref: "livePlayer",
    attrs: {
      options: _vm.playerOptions
    },
    on: {
      play: _vm.play
    }
  }) : _vm._e()], 1), _c("section", {
    staticClass: "nav"
  }, [_vm.liveInfo.liveDesc ? _c("div", {
    class: _vm.active == "desc" ? "active" : "",
    on: {
      click: function click($event) {
        _vm.active = "desc";
      }
    }
  }, [_vm._v("直播简介")]) : _vm._e(), _vm.contentData.length > 0 ? _c("div", {
    class: _vm.active == "pic" ? "active" : "",
    on: {
      click: function click($event) {
        _vm.active = "pic";
      }
    }
  }, [_vm._v("图文直播")]) : _vm._e(), _vm.liveInfo.commentControl ? _c("div", {
    class: _vm.active == "comment" ? "active" : "",
    on: {
      click: function click($event) {
        _vm.active = "comment";
      }
    }
  }, [_vm._v("互动聊天")]) : _vm._e()]), _vm.active == "desc" ? _c("section", {
    staticClass: "content_list"
  }, [_c("div", {
    staticClass: "introduce"
  }, [_vm._v(_vm._s(_vm.liveInfo.liveDesc))])]) : _vm._e(), _vm.active == "pic" ? _c("section", {
    ref: "contentList",
    staticClass: "content-list",
    on: {
      scroll: _vm.handleScroll
    }
  }, [_vm.contentData.length > 0 ? _c("div", {
    staticClass: "order-wrap"
  }, [_c("div", {
    staticClass: "order",
    on: {
      click: function click($event) {
        return _vm.handleOrder();
      }
    }
  }, [!_vm.order ? _c("img", {
    attrs: {
      src: require("@/assets/images/live/icon_positive_sequence.png")
    }
  }) : _c("img", {
    attrs: {
      src: require("@/assets/images/live/icon_positive_reverse.png")
    }
  }), _vm._v(_vm._s(!_vm.order ? "正序" : "倒序"))]), _c("div", {
    staticClass: "num"
  }, [_vm._v("共 " + _vm._s(_vm.liveInfo.infoCount) + " 条报道")])]) : _vm._e(), _c("van-list", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.active == "pic" && _vm.contentData.length,
      expression: "active == 'pic' && contentData.length"
    }],
    ref: "select1",
    staticClass: "list stick",
    attrs: {
      finished: _vm.contentFinished,
      "finished-text": "没有更多了"
    },
    on: {
      load: _vm.contentOnLoad
    },
    model: {
      value: _vm.contentLoading,
      callback: function callback($$v) {
        _vm.contentLoading = $$v;
      },
      expression: "contentLoading"
    }
  }, [_c("ul", {
    staticClass: "article-list"
  }, _vm._l(_vm.contentData, function (item, index) {
    return _c("li", {
      key: index
    }, [_c("div", {
      staticClass: "content-item"
    }, [_c("div", {
      staticClass: "left"
    }), _c("div", {
      staticClass: "detail"
    }, [_c("div", {
      staticClass: "content_title"
    }, [_c("img", {
      staticClass: "avatar",
      attrs: {
        src: item.photoUrl
      }
    }), _c("div", {
      staticClass: "right"
    }, [_c("div", {
      staticClass: "user"
    }, [_c("span", {
      staticClass: "people"
    }, [_vm._v(_vm._s(item.liveAuthorName))]), _c("span", {
      staticClass: "username"
    }, [_c("span", {
      staticClass: "color"
    }), _c("span", {
      staticClass: "type"
    }, [_vm._v(_vm._s(item.liveAuthorType))])])]), _c("div", {
      staticClass: "time"
    }, [_vm._v(" " + _vm._s(_vm._f("dateTransfer")(item.releaseDatetime)) + " ")])])]), item.contentTitle != "" ? _c("div", {
      staticClass: "big-title"
    }, [_vm._v(_vm._s(item.contentTitle))]) : _vm._e(), item.liveInfoType == 1 ? _c("div", {
      staticClass: "content_body",
      domProps: {
        innerHTML: _vm._s(item.contentTxt)
      },
      on: {
        click: function click($event) {
          return _vm.richClick($event, item);
        }
      }
    }) : item.liveInfoType == 2 ? _c("div", {
      staticClass: "content_body"
    }, [_c("div", {
      domProps: {
        innerHTML: _vm._s(item.contentTxt)
      },
      on: {
        click: function click($event) {
          return _vm.richClick($event, item);
        }
      }
    }), _vm._l(item.onlineLivePictureList, function (i, idx) {
      return _c("img", {
        directives: [{
          name: "lazy",
          rawName: "v-lazy",
          value: i.imgUrl,
          expression: "i.imgUrl"
        }],
        key: idx,
        style: {
          width: item.imgWidth,
          height: item.imgHeight
        },
        on: {
          click: function click($event) {
            return _vm.imgShow(item, idx);
          }
        }
      });
    })], 2) : item.liveInfoType == 3 ? _c("div", {
      staticClass: "content_body"
    }, [_c("div", {
      domProps: {
        innerHTML: _vm._s(item.contentTxt)
      },
      on: {
        click: function click($event) {
          return _vm.richClick($event, item);
        }
      }
    }), item.videoUrl ? _c("div", {
      staticClass: "video"
    }, [_vm.isAndroid && !_vm.client ? _c("div", {
      staticClass: "h5-video"
    }, [_c("img", {
      attrs: {
        src: item.videoImg
      }
    }), _c("img", {
      staticClass: "play-btn",
      attrs: {
        src: require("@/assets/images/live/icon_play_normal.png")
      },
      on: {
        click: function click($event) {
          return _vm.showH5Video(item.videoUrl, item.videoImg);
        }
      }
    })]) : _c("div", [_vm.showPlayVideo ? _c("d-player", {
      key: index + "live",
      ref: "player",
      refInFor: true,
      attrs: {
        options: item.playerOptions
      },
      on: {
        play: _vm.play
      }
    }) : _vm._e()], 1)]) : _vm._e()]) : item.liveInfoType == 4 ? _c("div", {
      staticClass: "comment-reply"
    }, [_c("div", {
      staticClass: "bg"
    }, [_c("div", {
      staticClass: "username"
    }, [_c("span", [_vm._v("回复：")]), _vm._v(_vm._s(item.commentNickName))]), _c("div", {
      staticClass: "reply",
      domProps: {
        innerHTML: _vm._s(item.commentContent)
      }
    })]), _c("div", {
      staticClass: "reply-content",
      domProps: {
        innerHTML: _vm._s(item.contentTxt)
      }
    })]) : _vm._e(), _c("a", {
      staticClass: "zan",
      on: {
        click: function click($event) {
          item.zanStatus == 1 ? _vm.addFav(item.liveInfoId, item.starNum, index) : "";
        }
      }
    }, [_c("img", {
      staticClass: "love",
      attrs: {
        src: require(item.zanStatus == 1 ? "@/assets/images/live/icon_like_normal.png" : "@/assets/images/live/icon_like_pressed.png")
      }
    }), _vm._v(" " + _vm._s(item.starNum) + " ")])])])]);
  }), 0)])], 1) : _vm._e(), _vm.active == "comment" ? _c("section", {
    ref: "commentList",
    staticClass: "comment-list",
    on: {
      scroll: _vm.handleScroll
    }
  }, [_c("div", {
    staticClass: "tips comment-item",
    staticStyle: {
      "margin-right": "58px"
    }
  }, [_vm._v("欢迎来到直播间，与主播在线留言互动；请文明留言，共同维护和谐直播环境。直播间内严禁出现违法违规、低俗色情、吸烟、酗酒、人身伤害等内容。")]), _vm.showComment ? _c("div", {
    staticClass: "item-wrap"
  }, _vm._l(_vm.commentList, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "comment-item"
    }, [_c("div", {
      staticClass: "nickname"
    }, [_vm._v(_vm._s(item.commentUserName) + "：")]), _c("div", {
      staticClass: "content"
    }, [item.commentType == "2" ? _c("img", {
      attrs: {
        src: item.commentText
      }
    }) : _c("span", [_vm._v(_vm._s(item.commentText))])])]);
  }), 0) : _vm._e()]) : _vm._e(), _c("comment-wrap", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.popEmojiShow && _vm.active == "comment",
      expression: "!popEmojiShow&&active=='comment'"
    }],
    ref: "commentWrap",
    attrs: {
      client: _vm.client,
      emojiOpen: _vm.popEmojiShow
    },
    on: {
      addTotalFav: _vm.addTotalFav,
      openDanmu: _vm.openDanmu,
      openEmoji: _vm.openEmoji,
      openShare: _vm.openShare,
      commentFocus: _vm.commentFocus
    }
  })], 1), _c("van-popup", {
    staticClass: "live-desc",
    attrs: {
      round: "",
      position: "bottom",
      overlay: false
    },
    model: {
      value: _vm.popShow,
      callback: function callback($$v) {
        _vm.popShow = $$v;
      },
      expression: "popShow"
    }
  }, [_c("h1", [_vm._v("简介")]), _c("div", [_vm._v(_vm._s(_vm.liveInfo.liveDesc))]), _c("img", {
    staticClass: "close",
    attrs: {
      src: require("@/assets/images/live/btn_live_close_normal@2x.png")
    },
    on: {
      click: function click($event) {
        _vm.popShow = false;
      }
    }
  })]), _c("van-popup", {
    staticClass: "emoji-pop",
    attrs: {
      position: "bottom",
      overlay: true,
      "lazy-render": false
    },
    model: {
      value: _vm.popEmojiShow,
      callback: function callback($$v) {
        _vm.popEmojiShow = $$v;
      },
      expression: "popEmojiShow"
    }
  }, [_c("div", {
    staticClass: "idea"
  }, [_c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.commentText,
      expression: "commentText"
    }],
    ref: "userCommentInput",
    staticClass: "userCommentInput",
    attrs: {
      type: "text",
      autofocus: true,
      placeholder: "发个评论~~",
      maxlength: "100"
    },
    domProps: {
      value: _vm.commentText
    },
    on: {
      blur: _vm.inputBlur,
      click: _vm.commentFocus,
      input: function input($event) {
        if ($event.target.composing) return;
        _vm.commentText = $event.target.value;
      }
    }
  }), _c("img", {
    attrs: {
      src: require("@/assets/images/live/btn_live_emoji_black_normal@2x.png")
    },
    on: {
      click: _vm.emojiClickHandle
    }
  }), _c("a", {
    on: {
      click: _vm.commentSubmit
    }
  }, [_vm._v("发送")])]), _vm.emojiShow ? _c("div", {
    staticClass: "emoji-wrap"
  }, _vm._l(_vm.emojiList, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "item"
    }, [_c("img", {
      attrs: {
        src: item.emoteUrl
      },
      on: {
        click: function click($event) {
          return _vm.sendEmoji(item);
        }
      }
    })]);
  }), 0) : _vm._e()]), _c("canvas", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.active == "desc" || _vm.active == "comment",
      expression: "active == 'desc' || active == 'comment'"
    }],
    staticClass: "canvas",
    attrs: {
      id: "cvs"
    }
  }), _c("van-image-preview", {
    attrs: {
      id: "img-preview",
      startPosition: _vm.imagesPosition,
      images: _vm.imagesList
    },
    model: {
      value: _vm.imagesShow,
      callback: function callback($$v) {
        _vm.imagesShow = $$v;
      },
      expression: "imagesShow"
    }
  }), _vm.x5VideoShow ? _c("div", {
    staticClass: "x5-videoPlayer"
  }, [_c("d-player", {
    ref: "contentPlayer",
    attrs: {
      options: _vm.dpOptions,
      id: "x5-dplayer"
    }
  }), _c("a", {
    staticClass: "close",
    on: {
      click: _vm.x5VideoCloseHandle
    }
  })], 1) : _vm._e(), [_vm.client ? _c("div", {
    staticClass: "fixed-right-bottom share-like",
    class: [_vm.showElement ? "share-show" : ""]
  }, [_c("div", {
    staticClass: "share-text",
    on: {
      click: _vm.openShare
    }
  }, [_vm._m(0), _c("span", [_vm._v("分享")])]), _c("div", {
    staticClass: "fav",
    on: {
      click: _vm.likeHeart
    }
  }, [_c("img", {
    attrs: {
      src: require("@/assets/images/live/btn_live_zan_normal@2x.png")
    }
  })]), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.active == "pic",
      expression: "active == 'pic'"
    }],
    staticClass: "to-top",
    on: {
      click: _vm.picToTop
    }
  }, [_c("img", {
    attrs: {
      src: require("@/assets/images/live/icon_top_top.png")
    }
  })])]) : _c("div", {
    staticClass: "fixed-right-bottom",
    class: [_vm.active == "pic" ? "share-like" : "", _vm.showElement ? "share-show" : ""]
  }, [_c("div", {
    staticClass: "fav",
    on: {
      click: _vm.likeHeart
    }
  }, [_c("img", {
    attrs: {
      src: require("@/assets/images/live/btn_live_zan_normal@2x.png")
    }
  })]), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.active == "pic",
      expression: "active == 'pic'"
    }],
    staticClass: "to-top",
    on: {
      click: _vm.picToTop
    }
  }, [_c("img", {
    attrs: {
      src: require("@/assets/images/live/icon_top_top.png")
    }
  })])])]], 2);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "share"
  }, [_c("img", {
    staticClass: "emoji",
    attrs: {
      src: require("@/assets/images/live/btn_share_normal@3x.png")
    }
  })]);
}];
render._withStripped = true;
export { render, staticRenderFns };